export default __webpack_public_path__ + "static/favicon-fecf5ddebe9c800d65cbc5f260fe70a1.png";